/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedShippingInfoLink_viewer$ref = any;
export type PdpSharedShippingInfoLink_viewer = {
    readonly buyerItemConversation?: {
        readonly serviceId: string | null;
    } | null;
    readonly " $refType": PdpSharedShippingInfoLink_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedShippingInfoLink_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "userId",
            "type": "String!"
        },
        {
            "kind": "RootArgument",
            "name": "itemId",
            "type": "String!"
        },
        {
            "kind": "RootArgument",
            "name": "fetchUser",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchUser",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "buyerItemConversation",
                    "storageKey": null,
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "buyerId",
                            "variableName": "userId"
                        },
                        {
                            "kind": "Variable",
                            "name": "itemId",
                            "variableName": "itemId"
                        }
                    ],
                    "concreteType": "Conversation",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "serviceId",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = '8eab7b42fce448dff41538cf9ddcb35c';
export default node;
